module.exports = __webpack_public_path__ + "static/media/analytics.f45a546d.svg";